const a = (t) => {
  const e = t.items.map((n) => ({
    sectionData: {
      iconName: n.icon,
      title: n.title,
      subTitle: n.description,
      link: n.link
    }
  })), o = t.isRenewalUrgent ?? !1;
  return {
    componentType: "my_account_container",
    userData: e,
    isRenewalUrgent: o
  };
};
export {
  a as default
};
//# sourceMappingURL=my-account-container-transformer.js.map
